// Anzeigenamen der Rollen (Werte wie bisher in Layout.jsx).
export const ROLLEN_NAMEN = {
  admin: 'Administrator',
  backoffice: 'Backoffice',
  personalmanager: 'Personalmanager',
  koordinator: 'Koordinator',
  geschaeftsfuehrung: 'Geschäftsführung',
  mitarbeiter: 'Mitarbeiter',
};

// Verwaltende Rollen (2FA, Erinnerung, Login-Merkzeichen) – eine Liste für alle.
export const VERWALTUNGS_ROLLEN = ['admin', 'backoffice', 'personalmanager', 'koordinator', 'geschaeftsfuehrung'];

export const rollenName = (rolle) => ROLLEN_NAMEN[rolle] || rolle;
